//请自行添加语言资源
const reservation = {
  orderNo: 'TMS单号',
  schOrderNo: '作业单号',
  schOrderTypeName: '作业单类型',
  shipperName: '货主',
  companyName:'所属机构',
  customerOrderNo: '客户订单号',
  soOrSto: '客户相关单号',
  orderType: '订单类型',
  orderStatus: '订单状态',
  orderDate:'订单日期',
  transType: '运输方式',
  reqDispatchDate: '要求发货日期',
  reqArriverDate: '要求送达时间',
  originAddrName: '发货方',
  originAddrContactMan: '发货人',
  originAddrContactTel: '发货人电话',
  originAddrProvinceName: '发货省份',
  originAddrCityName: '发货城市',
  originAddrDistrictName: '发货区/县',
  sendStreet: '发货街道',
  originAddrLocation: '发货地址',
  originAddrLongitude: '发货X坐标',
  originAddrLatitude: '发货y坐标',
  destAddrName: '收货方',
  destAddrContactMan: '收货人',
  destAddrContactTel: '收货人电话',
  destAddrProvinceName: '收货省份',
  destAddrCityName: '收货城市',
  destAddrDistrictName: '收货区/县',
  receiveStreet: '收货街道',
  destAddrLocation: '收货地址',
  destAddrLongitude: '收货X坐标',
  destAddrLatitude: '收货y坐标',
  totalQty: '总箱数',
  totalVolume: '总体积(m³)',
  totalWeight: '总毛重(KG)',
  totalNetWeight: '总净重(KG)',
  remark: '备注',
  seqType: '备货类型',
  seq: '序号',
  projectCode: '项目名称',
  truckNo:'车牌号',
  truckType: '车型',
  driverName: '司机',
  driverTel: '联系电话',
  carrierName: '承运商',
  loadWeight: '核载重量',
  loadVolume: '核载体积',
  driverLicense: '驾驶证',
  planExpToTime: '预计提货时间',
  transModel: '运输模式',
  appointmentDate: '预约日期',
  segment: '时间段',
  maxLoad: '最大装货量(m³)',
  surplusVol: '剩余装货量（m³）',
  urgentFlagName: '是否加急',
  orderProperty: '订单属性',
  orderClassify: '订单分类',
  msg:{
    truckNo: '请输入车牌号',
    driverName: '请输入司机姓名',
    mobile: '请输入手机号',
    carrierName: '请选择承运商',
    transType: '请选择运输方式',
    truckType: '请选择车辆类型',
    loadWeight: '请输入核载重量',
    loadVolume: '请输入核载体积',
  }
};
export default reservation



// WEBPACK FOOTER //
// ./src/page/transport/reservation/lang/reservation.zh.js